import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { submitFeedback } from '../lib/feedback';
import { trackEvent } from '../lib/analytics';
import AppBrand from '../components/AppBrand';

function FeedbackPage({ session, theme = 'dark' }) {
  const navigate = useNavigate();
  const darkMode = theme === 'dark';

  const [confusedText, setConfusedText] = useState('');
  const [usefulText, setUsefulText] = useState('');
  const [valuableFeatureText, setValuableFeatureText] = useState('');
  const [breakageText, setBreakageText] = useState('');
  const [payText, setPayText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    trackEvent('feedback_opened');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
    setMessage('');
    setError('');

    try {
      await submitFeedback({
        userId: session.user.id,
        confusedText,
        usefulText,
        valuableFeatureText,
        breakageText,
        payText,
      });

      setConfusedText('');
      setUsefulText('');
      setValuableFeatureText('');
      setBreakageText('');
      setPayText('');
      setMessage('Thanks — your feedback was submitted.');
      trackEvent('feedback_submitted');
    } catch (err) {
      console.error(err);
      setError(err.message || 'Failed to submit feedback.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={`legal-page-shell ${darkMode ? 'dark' : 'light'}`}>
      <div className="legal-page-container">
        <AppBrand theme={theme} />
        <div className="legal-page-topbar">
          <button
            type="button"
            className="back-link-btn"
            onClick={() => navigate('/')}
          >
            ← Back to App
          </button>
        </div>

        <div className="legal-page-card onboarding-page-card">
          <div className="legal-page-badge">Feedback</div>
          <h1 className="legal-page-title">Help Improve StockVested</h1>
          <p className="legal-page-updated">
            Share what worked, what confused you, and what would make the product more valuable.
          </p>

          {message ? <div className="feedback-success-banner">{message}</div> : null}
          {error ? <div className="journal-error-banner">{error}</div> : null}

          <form className="feedback-form" onSubmit={handleSubmit}>
            <div className="journal-field full">
              <label>What confused you?</label>
              <textarea
                value={confusedText}
                onChange={(e) => setConfusedText(e.target.value)}
                rows={4}
                placeholder="What felt unclear or hard to understand?"
              />
            </div>

            <div className="journal-field full">
              <label>What felt useful?</label>
              <textarea
                value={usefulText}
                onChange={(e) => setUsefulText(e.target.value)}
                rows={4}
                placeholder="What did you like or find helpful?"
              />
            </div>

            <div className="journal-field full">
              <label>What feature would make this more valuable?</label>
              <textarea
                value={valuableFeatureText}
                onChange={(e) => setValuableFeatureText(e.target.value)}
                rows={4}
                placeholder="What would improve the app the most?"
              />
            </div>

            <div className="journal-field full">
              <label>Did anything break?</label>
              <textarea
                value={breakageText}
                onChange={(e) => setBreakageText(e.target.value)}
                rows={4}
                placeholder="Describe bugs, errors, or confusing behavior."
              />
            </div>

            <div className="journal-field full">
              <label>Would you pay for this? Why or why not?</label>
              <textarea
                value={payText}
                onChange={(e) => setPayText(e.target.value)}
                rows={4}
                placeholder="Tell us how you think about the value of the product."
              />
            </div>

            <div className="feedback-form-actions">
              <button
                type="submit"
                className="journal-primary-button"
                disabled={submitting}
              >
                {submitting ? 'Submitting...' : 'Submit Feedback'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FeedbackPage;